import { render, staticRenderFns } from "./ResponsiveDialog.vue?vue&type=template&id=18057bd5&"
import script from "./ResponsiveDialog.vue?vue&type=script&lang=js&"
export * from "./ResponsiveDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports